// TODO: maybe replaced by
// https://github.com/Calvein/empty-module
// https://github.com/crimx/empty-module-loader
var ConfirmationDialog = {
  extend: () => {}
};

export { ConfirmationDialog as default };
//# sourceMappingURL=empty.js.map
